import superagent from 'superagent';
import Promise from 'bluebird';
import config from '../config';

class Connection {
  send(path, data, method = 'GET') {
    const url = `${config.BASE_API_URL}${path}`;
    const request = superagent(method, url)
      .withCredentials()
      .type('application/json')
      .accept('json');

    if (method === 'PUT' || method === 'POST') {
      request.send(data);
    } else {
      request.query(data);
    }

    return Promise.promisify(request.end.bind(request))()
      .then(resp => (resp.body), (err) => {
        const message = err.response.body
          ? err.response.body.error
          : err.message;

        const error = new Error(message);

        return Promise.reject(error);
      });
  }
}

export default new Connection();



// WEBPACK FOOTER //
// ./src/services/connection.js